<template>
  <div class="page-binding">
    <div class="page-header">
      <h2>金鹏账户管理-绑定金鹏卡</h2>
    </div>
    <div class="page-body">
      <action></action>
    </div>
    <div class="page-footer">
      <div class="mod-tip">
        <a-icon type="exclamation-circle" theme="filled" />如您个人信息与金鹏卡账户信息不一致（含手机、姓名、身份证号），请先修改个人信息后才能继续绑定金鹏卡，不得绑定他人金鹏卡账户。
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import Action from './components/Form'
import './index'

export default {
  created () {
    const params = queryString.parse(location.search)

    if (params.source === 'mobile' && params.userToken) {
      // 兼容移动端
      this.$ls.set('USER_CENTER_TOKEN', params.userToken, 2 * 60 * 60 * 1000)
    }
  },
  components: {
    Action
  }
}
</script>
